import { withStyles } from '@material-ui/core/styles';
import CustomerInfoWorkbench from './CustomerInfoWorkbench';
import styles from './styles';

export default withStyles(styles)(CustomerInfoWorkbench);
